import React from "react";
import { connect } from "react-redux";
import { Modal, Form, message } from 'antd';

import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicForm from "../../components/frame/DynamicForm";
import DynamicTable from "../../components/frame/DynamicTable";

import DynamicFilter from "../../components/frame/DynamicFilter";
import DynamicButton from "../../components/frame/DynamicButton";
import ReactAbstract from "../../components/abstract/React.abstract";
import UpdateLoggerService from "../../services/SystemSetting/update-logger-service";


class UpdateLogger extends ReactAbstract {

    customComponentWillMount() {
    }

    dataMode = 0
    initReload = false
    moduleName = "setting"
    childModuleName = "updateLogger"

    state = {
        currentModalStatus: false,
        currentIndex: null,
        currentData: {},
        currentDataStatus: "unload",
        filters: {
            start_time: null,
            end_time: null
        },
        data: [],
        dataStatus: "unload",
    }

    actions = {
        selectAction: UpdateLoggerService.selectUpdateLogger,
        createAction: UpdateLoggerService.createUpdateLogger,
        updateAction: UpdateLoggerService.updateUpdateLogger,
        deleteAction: UpdateLoggerService.deleteUpdateLogger,

        //updateAction: PendingApprovalService.updatePendingtimeApproval,
    }


    headerColumn = [{
        title: "新增",
        icon: "plus-circle-o",
        access: "c_value",
        click: () => this.createData()
    }, {
        title: "批量删除",
        icon: "delete",
        access: "d_value",
        click: this.publicDelete
    }
    ]
	createData = () => this.setState({
		currentData: {},
		currentModalStatus: true,
		currentDataStatus: "loaded",
		currentIndex: null
	})
    filterColumn = [
        {
            type: "date",
            label: "时间",
            key: "update_time",
        },
    ]

    tableColumn = [{
        title: '日志时间',
        dataIndex: 'update_time_str',
        key: 'update_time_str',
        className: 'table-global-head-small'
    }, {
        title: '创建人',
        dataIndex: 'created_user_name',
        key: 'created_user_name',
        className: 'table-global-head-small'
    }, {
        title: '操作',
        dataIndex: 'actions',
        key: 'actions',
        className: 'table-global-head-small',
        render: (text, record, index) => (
            <DynamicButton column={this.buttonColumn(text, record, index)}
            />
        )
    }
    ]

    formColumn = () => [{
        label: "日志时间",
        key: "update_time",
        type: "date",
        valueWidth:'230px',
        required: false,
    }
    , {
        label: "日志内容",
        key: "update_content",
        type: "textarea",
        span: 24,
        valueWidth: "760px",
        rules: {rows: 5}
    }, 
]

buttonColumn = (text, record, index) => [{
    size: "small",
    type: "default",
    icon: "edit",
    title: "编辑",
    access: "u_value",
    click: this.updateData.bind(this, record, index)
}
]
updateData = (record, index) => this.setState({
    currentData: this.dataSource().data.Data[index],
    currentModalStatus: true,
    currentDataStatus: "loaded",
    currentIndex: index
})

  

    render() {
        return (
            <div className="app-module-item">
                <div className="app-module-header">
                <DynamicButton column={this.headerColumn} 
						module={this.childModuleName}
						access={this.props.access} />
                    <DynamicFilter column={this.filterColumn}
                        value={this.dataSource().filters}
                        setFilter={this.publicChange} />
                </div>
                <Modal width="1000px"
                    visible={this.state.currentModalStatus}
                    title={this.state.currentIndex?"编辑日志":"新增日志"}
                    destroyOnClose={true}
                    onCancel={this.toggleCurrentModal}
                    onOk={this.publicSubmit} >
                    <DynamicForm column={this.formColumn}
                        form={this.props.form}
                        loadStatus={this.state.currentDataStatus}
                        dataSource={this.state.currentData} />
                </Modal>
                <div>
                    <DynamicTable column={this.tableColumn}
                        dataStatus={this.dataSource().dataStatus}
                        dataSource={this.dataSource().data.Data}
                        pagination={{
                            total: this.dataSource().data.Total,
                            pageSize: this.dataSource().data.PageSize,
                            current: this.dataSource().filters.page
                        }}
                        rowSelection={this.rowSelection}
                        setPageFilter={this.publicChange} />
                </div>
            </div>
        )
    }
}



const mapStateToProps = state => {
    return {
    }
}

const mapDispatchToProps = {
}

UpdateLogger = Form.create()(connect(mapStateToProps, mapDispatchToProps)(UpdateLogger));

export default LayoutWrapper(UpdateLogger);


// WEBPACK FOOTER //
// ./src/routes/SystemSetting/UpdateLogger.js